export const REQUESTS_CONTENT_CHECKBOX_COL_ID = 'bulkSelect';

export const REQUESTS_REASSOCIATE_AUTOMATION_IDS = {
  moveAction: 'requests-reassociate-move',
  dialog: 'requests-reassociate-dialog',
  modeExisting: 'requests-reassociate-mode-existing',
  modeCreate: 'requests-reassociate-mode-create',
  endpointCombobox: 'requests-reassociate-endpoint',
  pathField: 'requests-reassociate-path',
  confirm: 'requests-reassociate-confirm',
  cancel: 'requests-reassociate-cancel',
} as const;
